import React, { useEffect, useState } from 'react';
import formatString from "format-string-by-pattern";
import { FullUrlget } from '../helpers/api.helper';
import { toast } from 'react-toastify';
import { createPreRegistration, getPreRegistrationById, updatePreRegistration } from '../services/ficha.service';
import { useNavigate, useParams } from 'react-router-dom';
import AsyncSelect from "react-select/async";
import { getSupervisor } from '../services/user.service';

export default function PreCadastro() {
  let { id } = useParams();
  const isEdit = id ? true : false;

  const loadOptions = async (inputValue) => {
    let users = await getSupervisor();
    return users.data;
  };

  useEffect(() => {
    async function fetchData() {
      setIsloader(true);

      if (isEdit) {
        let registrationData = getPreRegistrationById(id);
        let supervisorsData = getSupervisor();
        
        const [register, supervisor ] = await Promise.all([registrationData, supervisorsData]);

        setNome(register.data.nome);
        setcpf(register.data.cpf);
        setcep(register.data.cep);

        setendereco(register.data.endereco);
        setnumero(register.data.numero);
        setbairro(register.data.bairro);
        setCidade(register.data.cidade);
        setEstado(register.data.estado);

        setTelFixo(register.data.telFixo);
        setTelCelular(register.data.telCelular);
        setEmail(register.data.email);

        const sup = supervisor.data.filter(x => x.codRevendedor === register.data.cod_supervisor);
        setSelectedValue(sup[0]);
      }

      setIsloader(false);
    }

    fetchData();
  }, []);

  const navigate = useNavigate();
  const CpfValidator = require('cpf-cnpj-validator');

  const [nome, setNome] = useState('');
  const [cpf, setcpf] = useState('');
  const [cpfInvalid, setInvalidcpf] = useState(false);
  const [cep, setcep] = useState('');
  const [cepResultSearch, setcepResultSearch] = useState(undefined);
  const [isLoader, setIsloader] = useState(false);

  const [endereco, setendereco] = useState('');
  const [numero, setnumero] = useState('');
  const [bairro, setbairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');

  const [value, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState('');

  const [telFixo, setTelFixo] = useState('');
  const [telCelular, setTelCelular] = useState('');
  const [email, setEmail] = useState('');

  const cpfHandleChange = (value) => {
    let isValid = CpfValidator.cpf.isValid(value);
    if (!isValid) setInvalidcpf(true);
    else setInvalidcpf(false);


    let formatCpf = formatString('000.000.000-00', value);
    setcpf(formatCpf);
  }

  const cepHandleChange = async (value) => {
    let formatCep = formatString('00000-000', value);
    if (value.length === 9) {
      let unformatedCep = value.replace('.', '').replace('-', '');


      let resultCpf = await FullUrlget(`http://viacep.com.br/ws/${unformatedCep}/json/`);
      let { data } = resultCpf;
      setcepResultSearch(resultCpf);

      //set all values end with cep search
      setendereco(data.logradouro);
      setbairro(data.bairro);
      setEstado(data.uf);
      setCidade(data.localidade);
    }
    else {
      setcepResultSearch(undefined);
    }

    setcep(formatCep);
  }

  const phoneHandleChange = (value) => {
    let formatPhone = formatString('(00)0000-0000', value);
    setTelFixo(formatPhone)
  }

  const mobilePhoneHandleChange = (value) => {
    let formatMobile = formatString('(00)00000-0000', value);
    setTelCelular(formatMobile);
  }

  const handleSaveOnclick = async () => {
    try {
      setIsloader(true);

      let values = {
        nome: nome,
        cpf: cpf,
        cep: cep,
        endereco: endereco,
        numero: numero,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        telFixo: telFixo,
        telCelular: telCelular,
        email: email,
        cod_supervisor: selectedValue?.codRevendedor
      }

      if (!nome) {
        toast.info('Campo nome não pode ser vazio!');
        setIsloader(false);
        return
      }
      else if (!telCelular) {
        toast.info('Campo Telefone celular não pode ser vazio!');
        setIsloader(false);
        return
      }
      else if (!cidade) {
        toast.info('Campo cidade não pode ser vazio!');
        setIsloader(false);
        return
      }
      else if (!selectedValue) {
        toast.info('Campo Supervisor não pode ser vazio!');
        setIsloader(false);
        return
      }
      // else if (!telFixo) {
      //   toast.info('Campo Telefone fixo não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!cpf) {
      //   toast.info('Campo CPF não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!cep) {
      //   toast.info('Campo CEP não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!endereco) {
      //   toast.info('Campo Endereço não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!numero) {
      //   toast.info('Campo Número não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!bairro) {
      //   toast.info('Campo Bairro não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!estado) {
      //   toast.info('Campo Estado não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }
      // else if (!email) {
      //   toast.info('Campo Email não pode ser vazio!');
      //   setIsloader(false);
      //   return
      // }

      let resultSaveRequest = undefined;
      if (!id) {
        resultSaveRequest = await createPreRegistration(values);
      }
      else {
        resultSaveRequest = await updatePreRegistration(values, id);
      }

      if (resultSaveRequest.status === 200) {
        toast.success('Pré Cadastro efetuado com sucesso');
        navigate("/pre-cadastro");
      }
      else if (resultSaveRequest.status === 400) {
        toast.warning('Ocorreu um erro ao enviar suas informações');
      }
      setIsloader(false);
    } catch (error) {
      setIsloader(false);
      toast.warning('Ocorreu um erro ao enviar suas informações');
    }
  }

  const handleInputChange = (value) => {
    setValue(value);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0 text-dark">
                {isEdit ? 'Editar Pré cadastro' : 'Novo Pré Cadastro'}
              </h1>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable">
              {/* Custom tabs (Charts with tabs)*/}
              <div className="card">
                <div className="card-header">
                  <div className="card-tools">
                    <ul className="nav nav-pills ml-auto">

                    </ul>
                  </div>
                </div>
                <div className="card-body">

                  <section>
                    <div className="container">
                      <form>
                        <div className="row">
                          <div className="col-9">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Nome</label>
                              <input type="text" className="form-control" aria-describedby="nomeHelp" name="nome" value={nome} onChange={(e) => setNome(e.target.value)} />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">CPF</label>
                              <input type="text" className="form-control" aria-describedby="emailHelp" value={cpf} onChange={(e) => cpfHandleChange(e.target.value)} />
                              {
                                cpfInvalid &&
                                <small id="emailHelp" className="form-text text-muted "><span className="text-danger">CPF inválido.</span></small>
                              }
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">CEP</label>
                              <input type="text" className="form-control" aria-describedby="emailHelp" value={cep} onChange={(e) => cepHandleChange(e.target.value)} />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Endereço</label>
                              <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" value={endereco} onChange={(e) => setendereco(e.target.value)} />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Número</label>
                              <input type="text" className="form-control" aria-describedby="emailHelp" value={numero} onChange={(e) => setnumero(e.target.value)} />
                            </div>
                          </div>

                        </div>

                        <div className="row">
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Bairro</label>
                              <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={bairro} onChange={(e) => setbairro(e.target.value)} />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Cidade</label>
                              <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={cidade} onChange={(e) => setCidade(e.target.value)} />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Estado</label>
                              <input type="text" readOnly={cepResultSearch ? true : false} className="form-control" aria-describedby="emailHelp" value={estado} onChange={(e) => setEstado(e.target.value)} />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Telefone Fixo</label>
                              <input type="text" className="form-control" aria-describedby="emailHelp" value={telFixo} onChange={(e) => phoneHandleChange(e.target.value)} />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">Telefone Celular</label>
                              <input type="text" className="form-control" aria-describedby="telCelular" value={telCelular} onChange={(e) => mobilePhoneHandleChange(e.target.value)} />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Email</label>
                          <input type="email" className="form-control" aria-describedby="emailHelp" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Supervisor</label>
                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            value={selectedValue}
                            getOptionLabel={(e) => e.nome}
                            getOptionValue={(e) => e.id}
                            loadOptions={loadOptions}
                            onInputChange={handleInputChange}
                            onChange={handleChange}
                          />
                        </div>

                        <button type="button" id="submit-btn" className={`btn btn-primary`} onClick={() => handleSaveOnclick()} ><span className={isLoader ? ' spinner-border spinner-border-sm' : ''}></span> Enviar</button>
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  )
}
